import { AxiosError, isCancel } from 'axios';

import { isKeyInObject, isObject } from '@/shared/lib/object';
import { ErrorResponse } from '@/domain';

export function isApiError(error: unknown): error is AxiosError<ErrorResponse> {
  return (
    isKeyInObject('isAxiosError', error) &&
    Boolean(error.isAxiosError) &&
    isKeyInObject('response', error) &&
    isObject(error.response)
  );
}

export function isCancelError(
  error: unknown
): error is AxiosError<ErrorResponse> {
  return isCancel(error);
}
